import { Box, Typography } from '@material-ui/core'
import React from 'react'
import { useAccountsTabs } from '../../../hooks/useAccountsTabs'
import { MarketplaceTab } from './ui/marketplaceTab'
import { makeStyles } from '@material-ui/core/styles'
import { MarketplaceSettingsSwitcher } from './ui/marketplaceSettingsRouter'

export const EditAccountPage = () => {
  const accountTabs = useAccountsTabs(true)
  const classes = useStyles()

  return (
    <Box className={classes.wrapper}>
      <Typography variant="h5" gutterBottom className={classes.title}>
        Управление аккаунтами
      </Typography>
      <Box className={classes.tabs}>
        {accountTabs.map((t, i) => <MarketplaceTab account={t} key={i}/>)}
      </Box>
      <MarketplaceSettingsSwitcher/>
    </Box>
  )
}

const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      width: '100%',
      maxWidth: '100vw',
      padding: '37px 26px',
      boxSizing: 'border-box'
    },
    title: {
      fontSize: 18,
      fontWeight: 600,
      lineHeight: '120%',
      letterSpacing: '0%',
      marginBottom: '0.35em'
    },
    tabs: {
      display: 'flex',
      gap: 40,
      marginTop: 20
    }
  })
)